<form [formGroup]="DinamicForm" >
    <div class="mt-2">
        <h6><span [innerHtml]="sanitizer.bypassSecurityTrustHtml(check?.label)"></span> <span class="text-danger ml-2">*</span> <small class="tx-danger" *ngIf="fieldisValid.campoEsValido(this.check.formControlName, DinamicForm)">{{check.validateMessage}}</small></h6>
        <angular-editor [formControlName]="this.check.formControlName" (blur)="dynamicEmit()" [config]="config" [placeholder]="check.target.placeholder"></angular-editor>
    </div>
</form>